<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text {{ selectedShippingType === 'courier' ? $t('edit_courier') : $t('edit_delivery_service') }}
        v-spacer
        v-btn(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.px-4
        v-layout(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="3" :size="50" color="basic600" indeterminate)
        template(v-else)
          select-courier(v-if="selectedShippingType === 'courier'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")
          select-local-delivery(v-if="selectedShippingType === 'local-delivery'" :parentRates.sync="rates" :parentSelectedFulfilment.sync="selectedFulfilment")
      v-card-actions.px-4.pb-4
        v-btn(color="success500" depressed height="40" @click="clickSave" :loading="isLoading" dark block)
          .button-AA-medium.basic100--text.mx-2 {{ $t('save_changes') }}

</template>

<script>
import { mapActions } from 'vuex'
import SelectCourier from '@/components/dialogs/yezzashipping/SelectCourier.vue'
import SelectLocalDelivery from '@/components/dialogs/yezzashipping/SelectLocalDelivery.vue'

export default {
  name: 'EditShipping',
  components: { SelectCourier, SelectLocalDelivery },
  props: ['open', 'lead', 'selectedShippingType', 'parentSelectedFulfilment', 'parentYezzaShipping'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    rates: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    },
    selectedFulfilment: {
      get () {
        return this.parentSelectedFulfilment
      },
      set (newValue) {
        this.$emit('update:parentSelectedFulfilment', newValue)
      }
    },
  },
  mounted () {
    this.fetchRates()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchRates () {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/rates/${this.lead.pid}`)
        .then(resp => {
          if (resp.data && resp.data.length > 0) {
            this.rates = resp.data
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSave () {
      if (!this.selectedFulfilment.signature) {
        let errorMessage = 'Please select a '
        if (this.selectedShippingType === 'courier') {
          errorMessage += 'courier to proceed'
        } else {
          errorMessage += 'local delivery to proceed'
        }
        this.showMessage(['error', errorMessage])
        return
      }
      this.isLoading = true
      this.$axios.patch(`/shipping/yezzashipping/${this.yezzaShipping.id}`, { fulfilment: this.selectedFulfilment })
        .then(resp => {
          this.yezzaShipping = resp.data
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_courier": "Edit courier",
    "edit_delivery_service": "Edit delivery service"
  },
  "id": {
    "edit_courier": "Sunting kurir",
    "edit_delivery_service": "Sunting layanan pengiriman"
  }
}
</i18n>